import Menu from './Compartido/Menu.jsx';
import PropiedadesBuscar from './Buscar/PropiedadesBuscar.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Buscar = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.elementosweb.meta_titulo}
                meta_descripcion={props.elementosweb.meta_descripcion}
                meta_keywords={props.elementosweb.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="Buscar"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <PropiedadesBuscar
                lang={props.lang}
                clientes={props.textoclientes}
                ruta={props.ruta}
                propiedades={props.propiedades}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default Buscar;

